<template>
    <div>
        <el-dialog :visible = "alterShow" :title="optionType.concat('提醒信息修改-').concat(coinType)"  width="1000px" @close="closeDialog">
            <el-form>
                <el-form-item label="链类型" >
                    <el-input v-model="chainType"></el-input>
                </el-form-item>
                <el-form-item label="中文内容" >
                    <el-input v-model="contentZh"></el-input>
                </el-form-item>
                <el-form-item label="英文内容" >
                    <el-input v-model="contentEn"></el-input>
                </el-form-item>
                <el-form-item label="韩文内容" >
                    <el-input v-model="contentKr"></el-input>
                </el-form-item>
                <el-form-item label="越南语内容">
                    <el-input v-model="contentVi"/>
                </el-form-item>
            </el-form>
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="handleSave()">保存</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    export default {
        name: "alterRemind",
        props:['coinType','optionType','alterShow','contentZh','contentEn','contentKr','contentVi','chainType','id'],
        methods:{
            ...mapActions('coinRemindSetting',['alterCoinRemind']),
            closeDialog(){
                this.$emit('refresh');
            },
            handleSave(){
                let data = {
                    id : this.id,
                    coinType : this.coinType,
                    contentZh : this.contentZh,
                    contentEn : this.contentEn,
                    contentKr : this.contentKr,
                    contentVi : this.contentVi,
                    chainType : this.chainType,
                    optionType : this.optionType === '充币' ? 'recharge':'extract'
                }
                this.alterCoinRemind(data).then( () =>{
                    this.$message({type:'success',message:'修改成功'})
                    this.closeDialog();
                })

            }
        }
    }
</script>

<style scoped>

</style>
